export interface CityItemInterface {
  cityName: string;
  citySlug: string;
}

export class ResponseTopCity {
  status: boolean;

  message: any;

  data: CityItemInterface[];

  constructor(data: any) {
    this.status = data.status || false;
    this.message = data.message || "";
    this.data = data.data || [];
  }
}
